import type { Directive } from 'vue'

import { useUserStore } from '@/stores/user'

export const permission: Directive<HTMLElement, string[]> = {
  mounted(el, binding) {
    const { value } = binding
    useUserStore().setUserInfoFromToken()
    const modules = useUserStore().allowedModules
    console.log('v-permission', value, modules)
    if (value && value instanceof Array && value.length > 0) {
      const requiredModules = value

      const hasPermission = modules.some((module: string) => {
        return requiredModules.includes(module)
      })
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need roles! Like v-permission="['admin','editor']"`)
    }
  },
}
